export default "__VITE_ASSET__DjQXYeJE__"